export default "__VITE_ASSET__d5aa4b98__"